import React from 'react'
import AssessmentComponent from './assessmentListComponent'

const AssessmentList = () => {
  return (
    <div className='row mt-4'>
      <div className='col-lg-12'>
        <div className='card'>
          <AssessmentComponent header={true} />
        </div>
      </div>
    </div>
  )
}

export default AssessmentList
